export default __webpack_public_path__ + "static/media/grafema_clivitalbio_08.6516acc0.mp4";